var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrowLeft = function SvgDoubleArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.108 15.328a.7.7 0 1 0 .99-.99L5.759 10l4.339-4.338a.7.7 0 1 0-.99-.99L4.274 9.505a.7.7 0 0 0 0 .99zm5.833 0a.7.7 0 1 0 .99-.99L11.593 10l4.338-4.338a.7.7 0 1 0-.99-.99l-4.834 4.833a.7.7 0 0 0 0 .99z",
    clipRule: "evenodd"
  })));
};
export default SvgDoubleArrowLeft;